import { Component, OnInit } from '@angular/core';
import { RepositoryService } from "../../shared/services/repository.service";
import { Risk } from "../../_interfaces/risk.model";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { DatePipe } from '@angular/common'
import { formatDate } from '@angular/common';
import { RiskUser } from './../../_interfaces/RiskUser.model';
import { Department } from '../../_interfaces/Department.model';
import { RiskImpact, RiskProbability, RiskService } from '../../shared/services/risk.service';
import { Observable } from 'rxjs';
import { RiskType } from '../../_interfaces/RiskType.model';
import { HeadlineRisk } from '../../_interfaces/HeadlineRisk.model';

@Component({
  selector: 'app-edit-risk',
  templateUrl: './edit-risk.component.html',
  styleUrls: ['./edit-risk.component.css']
})

export class EditRiskComponent implements OnInit {
  riskDetail: Risk;
  riskDetailsForm: FormGroup;
  submitting = false;
  public user: RiskUser;
  riskUsers: RiskUser[];
  departments: Department[];

  constructor(private formBuilder: FormBuilder,
    private repository: RepositoryService,
    private riskService: RiskService,
    private router: Router,
    private activeRoute: ActivatedRoute) { }

  ngOnInit() {
    this.riskDetailsForm = this.formBuilder.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
      cost: [0, [Validators.min(0)]],
      probability: ['', Validators.required],
      alert: [false, Validators.required],
      impact: [50, [Validators.min(0)]],
      riskType: ['', Validators.required],
      financialRiskType: [''],
      strategicRiskType: [''],
      operationalRiskType: [''],
      //emergingRiskSegment: ['', Validators.required],
      reviewAndUpdateDate: [''],
      notes: ['', Validators.required],
      reviewPeriod: ['', Validators.required],
      reviewDate: [''],

      riskOwnerId: ['', [Validators.required, Validators.min(0)]],
      riskManagerId: ['', [Validators.required, Validators.min(0)]],
      riskDepartmentId: ['',[ Validators.required, Validators.min(0)]],
    });

    this.user = this.repository.GetMyUser();

    this.getPeople();
    this.getDepartments();
    this.getRiskDetails();
  }

  get f() { return this.riskDetailsForm.controls; }

  get riskTypes$(): Observable<RiskType[]> {
    return this.riskService.riskTypes$;
  }

  get riskImpacts(): RiskImpact[] {
    return this.riskService.riskImpacts;
  }

  get riskProbabilites(): RiskProbability[] {
    return this.riskService.riskProbabilities;
  }

  public headlineRiskTypes$(riskType: number): Observable<HeadlineRisk[]> {
    return this.riskService.filterHeadlineRisks(riskType);
  }

  getRiskDetails() {
    let id: string = this.activeRoute.snapshot.params['id'];
    let apiUrl: string = `Risks/${id}`;

    this.repository.getData(apiUrl)
      .subscribe(res => {
        this.riskDetail = res as Risk;
        this.f.title.setValue(this.riskDetail.title);
        this.f.description.setValue(this.riskDetail.description);

        const probability = this.riskService.riskProbabilities.find(x => this.riskDetail.probability >= x.min && this.riskDetail.probability <= x.max);
        this.f.probability.setValue(probability.max);

        const impact = this.riskService.riskImpacts.find(x => this.riskDetail.impact >= x.min && this.riskDetail.impact <= x.max);
        this.f.impact.setValue(impact.max);

        this.f.alert.setValue(+this.riskDetail.alertLevel); 
        
        if (this.riskDetail.financialRiskType) {
          this.f.financialRiskType.setValue(+this.riskDetail.financialRiskType);
        }
        if (this.riskDetail.strategicRiskType) {
          this.f.strategicRiskType.setValue(+this.riskDetail.strategicRiskType);
        }
        if(this.riskDetail.operationalRiskType) {
          this.f.operationalRiskType.setValue(+this.riskDetail.operationalRiskType);
        }
        this.f.riskType.setValue(this.riskDetail.riskType);
        //if (this.riskDetail.emergingRiskSegment) {
        //  this.f.emergingRiskSegment.setValue(+ this.riskDetail.emergingRiskSegment);
        //}

        if (this.riskDetail.reviewPeriod) {
          this.f.reviewPeriod.setValue(+this.riskDetail.reviewPeriod);
        }
 

        if (this.riskDetail.lastReviewDate !== null) {
          this.f.reviewAndUpdateDate.setValue(formatDate(this.riskDetail.lastReviewDate, 'yyyy-MM-dd', 'en'));
        }

        if (this.riskDetail.nextReviewDate !== null) {
          // Calculate next review date assuming risk is being reviewed now
          var nextReviewDate = new Date();
          nextReviewDate.setDate(nextReviewDate.getDate() + this.riskDetail.reviewPeriod);
          this.f.reviewDate.setValue(formatDate(nextReviewDate, 'yyyy-MM-dd', 'en'));
        }

        try {
          this.f.riskManagerId.setValue(+this.riskDetail.lineManager);
          this.f.riskOwnerId.setValue(+this.riskDetail.owner);
          this.f.riskDepartmentId.setValue(+this.riskDetail.department);
          //this.f.notes.setValue(this.riskDetail.notes);
        }
        catch (error) {
          alert(error.message);  
        }
        


      });
  }

  saveRiskDetails() {
      let apiAddress: string = `Risks`;

      this.repository.update(apiAddress, this.riskDetail)
        .subscribe(res => {
          // this.riskDetail = res as Risk;
          //this.router.navigate(["../../risks"], { relativeTo: this.activeRoute });
          this.router.navigate([`/myrisks/list`]);
        }, error => {
          //console.error("Error: ", error);
          alert('Error:!' + error.message + '\n\n');
          this.router.navigate([`/myrisks/list`]);
        },
          () => this.router.navigate([`/myrisks/list`])
        );
 
  }

  updateRiskFromForm() { 
    this.riskDetail.probability = +this.f.probability.value;
    this.riskDetail.alertLevel = +this.f.alert.value;
    this.riskDetail.impact = + this.f.impact.value || 50; // default to 'medium'
    this.riskDetail.riskType = +this.f.riskType.value;
    this.riskDetail.financialRiskType = +this.f.financialRiskType.value;
    this.riskDetail.strategicRiskType = +this.f.strategicRiskType.value;
    this.riskDetail.operationalRiskType = +this.f.operationalRiskType.value;


    //if (this.f.emergingRiskSegment.value) {
    //  this.riskDetail.emergingRiskSegment = + this.f.emergingRiskSegment.value;
    //}

    this.riskDetail.reviewPeriod = +this.f.reviewPeriod.value;
    this.riskDetail.lastReviewDate = this.f.reviewAndUpdateDate.value;
    this.riskDetail.nextReviewDate = this.f.reviewDate.value
    this.riskDetail.lineManager = +this.f.riskManagerId.value
    this.riskDetail.owner = +this.f.riskOwnerId.value
    this.riskDetail.department = +this.f.riskDepartmentId.value
    

    // non-numeric fields
    this.riskDetail.title = this.f.title.value;
    this.riskDetail.description = this.f.description.value;
    this.riskDetail.mitigatingActions = "";
    this.riskDetail.riskStatus = 3; // Active Risk (i.e. not emerging risk)
    this.riskDetail.notes = this.f.notes.value;
  }

  onCancelForm() {
    let riskMitigationUrl: string = `/myrisks/list`;
    this.router.navigate([riskMitigationUrl]);
  }

  onSubmit() {
    this.submitting = true;

    if (this.riskDetailsForm.valid) {
      this.updateRiskFromForm();
      this.saveRiskDetails();
      return;
    }

    this.riskDetailsForm.markAllAsTouched();
    this.submitting = false;
  }

  public setReviewDateFromPeriod(period: number) {
    let reviewDate = new Date(); // updates the review date from the curret edit date
    let reviewDays = +period;

    reviewDate.setDate(reviewDate.getDate() + reviewDays);

    this.f.reviewDate.setValue(formatDate(reviewDate, 'yyyy-MM-dd', 'en'));
  }

  public setReviewDateFromLastReview() {
    let reviewDate = new Date(this.f.reviewAndUpdateDate.value);
    let reviewDays = + this.f.reviewPeriod.value;

    reviewDate.setDate(reviewDate.getDate() + reviewDays);

    this.f.reviewDate.setValue(formatDate(reviewDate, 'yyyy-MM-dd', 'en'));
  }

  public getPeople() {
    let apiAddress: string = `Users/UserList`;
    this.repository.getData(apiAddress)
      .subscribe(res => {
        this.riskUsers = res as RiskUser[];
      });
  }

  public getDepartments() {
    let apiAddress: string = `Departments`; 
    this.repository.getData(apiAddress)
      .subscribe(res => {
        this.departments = res as Department[];
      });
  }


}
